export default function getScript(url, callback) {
  const isExist = document.querySelector(`script[src="${url}"]`);
  if (isExist) {
    callback();
    return;
  }
  const script = document.createElement("script");
  script.type = "text/javascript";
  script.onload = callback;
  script.src = url;
  const head = document.head || document.head.getElementsByTagName("head")[0];
  head.appendChild(script);
}
